import React, { Suspense } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import ReactDOM from 'react-dom';
import { Route, BrowserRouter, Switch, Redirect } from 'react-router-dom';
import { AnimatedPageLoader } from 'smartsuite-ui';
import DashboardAppWrapper from './apps/Dashboard/AppWrapper';
import ConfigurationAppWrapper from './apps/Configuration/ConfigurationAppWrapper';
import AdvancedSearchAppWrapper from './apps/AdvancedSearch/AppWrapper';
import FlightStatusToolWrapper from './apps/FlightStatusTool/AppWrapper';
import BagSummary from './apps/BagSummary/AppWrapper';
import ErrorBoundary from './components/ErrorBoundary';

import 'smartsuite-ui/dist/smartsuite-ui.css';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');

const queryClient = new QueryClient({
    defaultOptions: { queries: { refetchOnWindowFocus: false } },
});

// TODO: Remove apps/framework/ portion once we use our own configs separate from Operational
ReactDOM.render(
    <Suspense fallback={<AnimatedPageLoader />}>
        <QueryClientProvider client={queryClient}>
            <ErrorBoundary>
                <BrowserRouter basename={baseUrl}>
                    <Switch>
                        <Route
                            path="/"
                            exact={true}
                            render={() => (
                                <Redirect to="BagSummary" />
                            )}
                        />
                        <Route
                            path="/Dashboard"
                            component={({ match }) => (
                                <DashboardAppWrapper path={match.path} />
                            )}
                        />
                        <Route
                            path="/AdvancedSearch"
                            component={({ match }) => (
                                <AdvancedSearchAppWrapper path={match.path} />
                            )}
                        />
                        <Route
                            path="/Configuration"
                            component={({ match }) => (
                                <ConfigurationAppWrapper path={match.path} />
                            )}
                        />
                        <Route
                            path="/FlightStatus"
                            component={({ history }) => (
                                <FlightStatusToolWrapper history={history} />
                            )}
                        />
                        <Route path="/BagSummary/:bagTag?/:id?">
                            <BagSummary />
                        </Route>
                    </Switch>
                </BrowserRouter>
            </ErrorBoundary>
        </QueryClientProvider>
    </Suspense>,
    document.getElementById('root')
);

// registerServiceWorker();
